/**
 * 搜索栏通用组件
 */

import React from 'react';
import { Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { SearchProps } from 'antd/es/input/Search';

interface SearchBarProps extends SearchProps {
  placeholder?: string;
  onSearch?: (value: string) => void;
  width?: number | string;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = '搜索...',
  onSearch,
  width = 240,
  className,
  ...props
}) => {
  return (
    <Space.Compact className={className}>
      <Input
        prefix={<SearchOutlined />}
        placeholder={placeholder}
        onSearch={onSearch}
        onPressEnter={(e: React.KeyboardEvent<HTMLInputElement>) => {
          onSearch?.((e.target as HTMLInputElement).value);
        }}
        style={{ width }}
        {...props}
      />
    </Space.Compact>
  );
};

export default SearchBar;
